import DynamicLegal from "@/pages/legal/DynamicLegal";

export default function Terms() {
  return <DynamicLegal pageKey="terms" />;
}
